import _ from 'lodash'

export const sortedClasses = (objects) => {
  return _.orderBy(
    _.values(objects), ['object.grade', 'object.name'], ['asc', 'asc']
  )
}
